import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: () => import('../views/Login.vue'), meta: { public: true } },
  {
    path: '/',
    component: () => import('../views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard',   component: () => import('../views/Dashboard.vue'),  meta: { title: '首页' } },
      { path: 'admin-users', component: () => import('../views/AdminUsers.vue'), meta: { title: '账号管理' } },
      { path: 'suppliers',   component: () => import('../views/Suppliers.vue'),  meta: { title: '供应商管理' } },
      { path: 'products',    component: () => import('../views/Products.vue'),   meta: { title: '产品管理' } },
      { path: 'customers',   component: () => import('../views/Customers.vue'),  meta: { title: '客户管理' } },
      { path: 'quotations',  component: () => import('../views/Quotations.vue'), meta: { title: '报价管理' } },
      { path: 'orders',      component: () => import('../views/Orders.vue'),     meta: { title: '订单管理' } },
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({ mode: 'history', routes })

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (!to.meta.public && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
